import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../images/BrightBeginningLogoSun.png';

import bright from '../images/bright.png';
import beginning from '../images/beginning.png';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar">
      <div className="navbar__logo">
        <img src={logo} alt="Bright Beginning School Logo" />
        <img src={bright} alt="Bright" className = "cull" />
        <img src={beginning} alt="Beginning" className = "cull"/>
        <Link to="/"  onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}   className = "uncull">Bright Beginning Elementary School</Link>
      </div>

      {/* Hamburger Button */}
      <button className="navbar__toggle" onClick={toggleMenu}>
        ☰
      </button>

      {/* Links */}
      <ul className={`navbar__links ${menuOpen ? 'active' : ''}`}>
        <li>
          <Link to="/" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Home</Link>
        </li>
        <li className="dropdown">
          <Link to="/about" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }} className="dropdown-trigger">
            About ▾
          </Link>
          <ul className="dropdown-menu">
            <li><Link to="/about#about">About Us</Link></li>
            <li><Link to="/about#classenvironment">Class Environment</Link></li>
            <li><Link to="/about#parentinvolvement">Parent Involvement</Link></li>
            <li><Link to="/about#postgrad">Post Graduation</Link></li>
          </ul>
        </li>
        <li className="dropdown">
          <Link to="/programs" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }} className="dropdown-trigger">
            Programs ▾
          </Link>
          <ul className="dropdown-menu">
            <li><Link to="/programs#english">English</Link></li>
            <li><Link to="/programs#bengali">Bengali</Link></li>
            <li><Link to="/programs#math">Math</Link></li>
            <li><Link to="/programs#science">Science</Link></li>
            <li><Link to="/programs#globalstudies">Global Studies</Link></li>
            <li><Link to="/programs#additionalactivities">Additional Activities</Link></li>
          </ul>
        </li>
        <li>
          <Link to="/gallery" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Gallery</Link>
        </li>
        <li>
          <Link to="/contact" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>Contact</Link>
        </li>
      </ul>
    </nav>
  );
}
